import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import InputMask from 'react-input-mask';
import lang from '../../constants/Languages.js';

const DateRangeField = ({ input, label, type, placeholder, mask, name, disabled, clang, meta: { touched, error, warning } }) => {
    return (
        <div className="date-range__date">
            <label className="date-range__date-label">
                <span className="date-range__date-label-name">{label}:</span>
                <InputMask {...input} mask={mask} placeholder={placeholder} disabled={disabled}
                    className="date-range__date-input"/>
                {touched &&
                    (error && <span className="date-range__field-error">{lang[clang].date_range[error]}</span>)}
            </label>
        </div>
    );
};

DateRangeField.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(DateRangeField);



// WEBPACK FOOTER //
// ./src/components/date-range/DateRangeField.js